import { createApp } from './main'

const { app, router, pinia } = createApp()

// 只水合 ssrData store，不覆盖 user 等其他 store 的登录状态
if ((window as any).__pinia?.ssrData) {
  pinia.state.value.ssrData = (window as any).__pinia.ssrData
}

// 等路由就绪后再挂载，确保 SSR 水合匹配
router.isReady().then(() => {
  app.mount('#app')
})
